export default "__VITE_ASSET__B2hXikz4__"